document.addEventListener("DOMContentLoaded", function () {
    const vatFields = document.querySelector('[data-require-invoice]');
    const invoiceCheckbox = document.getElementById("attributes[Invoice]");
    const checkoutButton = document.getElementById("checkout");
    const companyFieldInput = document.getElementById("company-name");
    const vatFieldInput = document.getElementById("vatcodenumber-fiscalcode");
    const pecFieldInput = document.getElementById("pec-sdi");

    function getOrCreateErrorElement(id, fieldInput, message) {
        let errorElement = document.getElementById(id);
        if (!errorElement) {
            errorElement = document.createElement("span");
            errorElement.id = id;
            errorElement.className = "error hidden";
            errorElement.textContent = message;
            fieldInput.parentNode.appendChild(errorElement);
        }
        return errorElement;
    }

    const companyError = getOrCreateErrorElement("company-error", companyFieldInput, "Inserire la Ragione sociale.");
    const vatError = getOrCreateErrorElement("vat-error", vatFieldInput, "Inserire una Partita IVA (11 cifre) o un Codice Fiscale valido (16 caratteri).");
    const pecError = getOrCreateErrorElement("pec-error", pecFieldInput, "Inserire una PEC valida o un codice SDI (7 caratteri alfanumerici).");

    // Funzione per validare Partita IVA o Codice Fiscale
    function validateVatField(value) {
        const partitaIvaPattern = /^\d{11}$/; // Solo 11 cifre
        const codiceFiscalePattern = /^[A-Z0-9]{16}$/i; // 16 caratteri alfanumerici
        return partitaIvaPattern.test(value) || codiceFiscalePattern.test(value);
    }

    // Funzione per validare PEC o SDI
    function validatePecField(value) {
        const pecPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email valida
        const sdiPattern = /^[A-Z0-9]{7}$/i; // 7 caratteri alfanumerici
        return pecPattern.test(value) || sdiPattern.test(value);
    }

    // Mostra/nascondi i campi fattura in base al checkbox
    function toggleInvoiceFields(checkbox) {
        if (checkbox.checked) {
            vatFields.classList.remove("hidden");
            validateInvoiceFields(); // Validazione iniziale
        } else {
            vatFields.classList.add("hidden");
            companyError.classList.add("hidden");
            vatError.classList.add("hidden");
            pecError.classList.add("hidden");
            checkoutButton.disabled = false; // Abilita il pulsante
        }
    }

    // Validazione generale dei campi fattura
    function validateInvoiceFields() {
        if (invoiceCheckbox.checked) {
            const isCompanyValid = companyFieldInput.value.trim().length > 0;
            const isVatValid = validateVatField(vatFieldInput.value.trim());
            const isPecValid = validatePecField(pecFieldInput.value.trim());

            // Mostra o nasconde il messaggio di errore per Ragione sociale
            if (!isCompanyValid) {
                companyError.classList.remove("hidden");
            } else {
                companyError.classList.add("hidden");
            }

            // Mostra o nasconde il messaggio di errore per Partita IVA/Codice Fiscale
            if (!isVatValid) {
                vatError.classList.remove("hidden");
            } else {
                vatError.classList.add("hidden");
            }

            // Mostra o nasconde il messaggio di errore per PEC/SDI
            if (!isPecValid) {
                pecError.classList.remove("hidden");
            } else {
                pecError.classList.add("hidden");
            }

            // Disabilita il pulsante se uno dei campi non è valido
            checkoutButton.disabled = !(isCompanyValid && isVatValid && isPecValid);
        }
    }

    // Event listeners
    invoiceCheckbox.addEventListener("change", () => toggleInvoiceFields(invoiceCheckbox));
    companyFieldInput.addEventListener("input", validateInvoiceFields);
    vatFieldInput.addEventListener("input", validateInvoiceFields);
    pecFieldInput.addEventListener("input", validateInvoiceFields);
});
